import { render, staticRenderFns } from "./BotFlow.vue?vue&type=template&id=c60e9bb4"
import script from "./BotFlow.vue?vue&type=script&lang=js"
export * from "./BotFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports